module.exports = __webpack_public_path__ + "static/media/background.77a16c95.png";